<template>
  <div :style="{width:'450px'}">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.FLCLType')"
      :close-on-click-modal="false"
      class="app-main-inner"
      width="500px"
    >
      <div>
        <el-radio-group v-model="cargoType">
          <el-radio v-for="item in containerLoadTypeList" :key="item.code" :no="item.code" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-radio>
        </el-radio-group>

      </div>

      <cargo-ag-grid
        v-if="showRule"
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'350px',height:'200px'}"
        @gridReady="params=>gridApi=params.api"
      />
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="selectedHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _cargoTypeInputList } from '@/class/cargo/model/parameters/ImportConstants'

export default {
  name: 'SeaImContainerTypeDialog',
  props: {
    visible: { type: Boolean, required: true },
    showRule: { type: Boolean, required: true },
    rules: { type: Array }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single'
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.CodeRuleDesc'),
          field: 'ruleDesc',
          suppressMenu: true,
          width: 340
        }
      ],
      rowData: [],
      containerLoadTypeList: _cargoTypeInputList,
      cargoType: _cargoTypeInputList[0].code
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rowData = this.rules
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.rowData = this.rules
    }
  },
  methods: {
    selectedHandler() {
      let jobNoRule = null
      if (this.showRule) {
        const rows = this.gridApi.getSelectedRows()
        if (!rows || rows.length <= 0) {
          this.$message.info(this.$t('Message.PleaseSelectACodingRule'))
          return
        }
        if (rows.length > 0) {
          jobNoRule = this.rowData[0].jobNoRule
        }
      }
      console.log('===this.cargoType==', this.cargoType)
      this.$emit('selectedBack', { jobNoRule: jobNoRule, cargoType: this.cargoType })
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
